// @/common/api/cache/colorPaletteApi.js
import { sendRequest } from '@/common/sendRequest';

const colorPaletteApi = {
  /**
   * 색상 데이터 전체 조회 (GET)
   */
  async getAllColors() {
    return sendRequest('/api/public/common/materialnaturalcolor/all', {
      method: 'GET',
    });
  },

  /**
   * 색상 데이터 캐시 리로드 (POST)
   */
  async reloadColorPalette() {
    return sendRequest('/api/public/common/materialnaturalcolor/reload', {
      method: 'POST',
    });
  },
};

export default colorPaletteApi;